import React from "react";
import compose from "recompose/compose";
import { graphql } from "react-apollo";
import { withErrorBoundary } from "theme/components/helpers/ErrorBoundary";
import PageError from "theme/modules/PageError";

const filterIncludedCategories = (category) => ({
  ...category,
  children: category.children
    ? category.children
        .filter(({ include_in_menu }) => include_in_menu)
        .map(filterIncludedCategories)
    : [],
});

const EnhanceMenuNavigation = ({ MenuNavigationQuery }) =>
  compose(
    withErrorBoundary(() => <PageError />),
    graphql(MenuNavigationQuery, {
      props: ({ data }) => {
        return {
          categories: data.loading
            ? []
            : data.navigationMenu &&
              data.navigationMenu
                .filter(({ include_in_menu }) => include_in_menu)
                .map(filterIncludedCategories),
        };
      },
    })
  );

export default EnhanceMenuNavigation;
